const HAMRS_API_URL = 'https://api.hamrs.app/v1';
import type { PotaParkType, PotaSpotType, SotaSpotType, OperatorType, SolarConditionsType } from "@/types";

const HamrsApiService = {

  async fetchPark(parkId: string): Promise<PotaParkType> {
    try {
      console.log('fetching park from api', parkId)
      const response = await fetch(`${HAMRS_API_URL}/pota/parks/${parkId}`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching the park: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch park: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  },

  async fetchParks(since: number = 0): Promise<PotaParkType[]> {
    try {
      const response = await fetch(`${HAMRS_API_URL}/pota/parks?updated_since=${since}`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching parks: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch parks: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  },

  async fetchSpots(): Promise<PotaSpotType[]> {
    try {
      const response = await fetch(`${HAMRS_API_URL}/pota/spots`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching spots: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch spots: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  },

  async fetchSotaSpots(): Promise<SotaSpotType[]> {
    try {
      const response = await fetch(`${HAMRS_API_URL}/sota/spots`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching SOTA spots: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch SOTA spots: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  },

  async fetchSolarConditions(): Promise<SolarConditionsType> {
    try {
      const response = await fetch(`${HAMRS_API_URL}/solar`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching solar conditions: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch solar conditions: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  },

  async fetchOperator(callsign: string): Promise<OperatorType> {
    try {
      console.log('fetching operator from api', callsign)
      const response = await fetch(`${HAMRS_API_URL}/operators/${callsign.toUpperCase()}`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching the operator: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch operator: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  },

  async fetchOperators(since: number = 0): Promise<OperatorType[]> {
    try {
      const response = await fetch(`${HAMRS_API_URL}/operators?updated_since=${since}`);
      if (!response.ok) {
        throw new Error(
          `An error occurred while fetching operators: ${response.status} ${response.statusText}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch operators: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}

export default HamrsApiService